// Bulk-add entry screen: the grid of active review sessions (resume/delete) plus
// a "Créer une nouvelle revue" card. There is no Historique section — completed
// sessions simply disappear (no archive in this rework).
import { BulkSessionCard } from '@/components/words/bulk-add/bulk-session-card';
import { WordShellTopbar } from '@/components/words/word-shell-topbar';
import { useBulkAdd } from '@/lib/bulk-add/bulk-session';

/** The bulk-add landing screen (active sessions + create card). */
export function BulkEntry() {
  const bulk = useBulkAdd();

  return (
    <>
      <WordShellTopbar />
      <div className="bulk bulk--full">
        <header className="bulk-entry__head">
          <h1 className="bulk-entry__title">Ajout en masse</h1>
          <p className="bulk-entry__subtitle">
            Créez une revue pour ajouter plusieurs mots d'un coup.
          </p>
        </header>

        <div className="bulk-cards">
          {bulk.sessions.map((session) => (
            <BulkSessionCard
              key={session.id}
              session={session}
              onResume={() => bulk.openSession(session.id)}
              onDelete={() => bulk.cancelSession(session.id)}
            />
          ))}

          <button type="button" className="bulk-card bulk-card--new" onClick={bulk.startNew}>
            <span className="material-symbols-rounded bulk-card--new__icon" aria-hidden="true">
              add
            </span>
            Créer une nouvelle revue
          </button>
        </div>
      </div>
    </>
  );
}
